import { IconFlame } from "@tabler/icons-react";
import type * as React from "react";

import { cn } from "@/lib/utils";

/** Amber surface tokens shared with the global capacity notice banner. */
export const capacityNoticeAmberSurfaceClassName = "bg-amber-400 text-amber-950";

export const capacityNoticeIconClassName = "size-4 shrink-0 text-amber-950";

export const capacityNoticeAdmonitionClassName = cn(
  capacityNoticeAmberSurfaceClassName,
  "flex items-start gap-3 rounded-lg border border-amber-500 px-4 py-3 text-sm leading-snug",
);

export const CapacityNoticeAdmonition = ({
  children,
  className,
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => (
  <div role="status" id={id} className={cn(capacityNoticeAdmonitionClassName, className)}>
    <IconFlame className={capacityNoticeIconClassName} aria-hidden />
    <p className="min-w-0 flex-1">{children}</p>
  </div>
);
